import { ReactElement } from 'react';
import { Divider } from '@mui/material';

import { CosmostationWalletConnectButton } from 'modules/auth/components/CosmostationWalletConnectButton';
import { MetamaskSnapConnectButton } from 'modules/auth/components/MetamaskSnapConnectButton';
import { Dialog, KnownDialogs, useDialog } from 'modules/dialogs';
import { useTranslation } from 'modules/i18n';

import { IotaWalletConnectButton } from '../IotaWalletConnectButton';
import { NightlyWalletConnectButton } from '../NightlyWalletConnectButton';
import { translation } from './translation';

const dividerSx = { visibility: 'hidden', mb: 4 };

export function WalletsDialog(): ReactElement {
  const { isOpened, onClose } = useDialog(KnownDialogs.connect);
  const { t, keys } = useTranslation(translation);

  return (
    <Dialog header={t(keys.connectWallet)} open={isOpened} onClose={onClose}>
      <div>
        <IotaWalletConnectButton />

        <Divider sx={dividerSx} />

        <MetamaskSnapConnectButton />

        <Divider sx={dividerSx} />

        <NightlyWalletConnectButton />

        <Divider sx={dividerSx} />

        <CosmostationWalletConnectButton />
      </div>
    </Dialog>
  );
}
